import React from "react";
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import Container from '@mui/material/Container';
import styles from './SupportUs.module.css';
import Image from "next/image";

function SupportUs(props) {
  const { cTAEightData, } = props;

  return (
    <div className="Section">

      <Container maxWidth="lg">
        <div className={styles.CTAEight} style={{ background: props.backgroundColor, minHeight: props.minHeight }}>

          <div className={styles.CTAEightLeftCol} style={{ background: props.backgroundColor, minHeight: props.minHeight }}>
            <div className={styles.CTAEightInner}>
              <div className={styles.CTAEightLeftColTitle}>{props.TitleLeft}</div>
              <div className={styles.CTAEightLeftColDescription}>{props.LeftDescription} <span>{props.bookname}</span></div>
              <div className={styles.CTAEightLeftBottomText}>{props.LeftBottomText}</div>
            </div>

          </div>


          <div className={styles.CTAEightRightCol} style={{ background: props.backgroundColorRight, minHeight: props.minHeight }}>
            <div className={styles.CTAEightInner}>
              <h2 style={{ color: props.color }}>{props.Title}</h2>

              <div className={styles.CTAEightRightColBtn}>
                {cTAEightData.map((item, i) => (

                  <a href={item.link} target={props.target} style={{ color: props.btnlebelcolor }} onClick={item.onClick}>
                    <div className={styles.CTAEightLogoLeft}>
                      <span>
                        {item.lebel}
                      </span>
                      <div className={styles.CTAEightLogoCtn}>
                        {item.IconStatus && 
                        <img src={item.icon} style={{marginLeft:item.space, height:item.Iconheight}}/> } <span>{item.TitleafterLogo}</span>
                       
                      </div>
                    </div>

                    <ArrowForwardIosRoundedIcon />
                  </a>
                ))}
              </div>

            </div>
          </div>

        </div>
      </Container>
    </div>
  );
}

export default SupportUs;
